import React from "react";
import "./navBar.css";
import logo from "../../assets/img/landing/app-logo.png";
// import { appName } from "helpers";

function NavBar() {
    return (
        <>
            <nav>
                <div className="container">
                    <input id="nav-toggle" type="checkbox" />
                    <div className="logo">
                        <img
                            src={logo}
                            alt=""
                            width={30}
                        />
                        <strong>
                            <a href="/">certify.social</a>
                        </strong>
                    </div>
                    <ul className="links">
                        <li><a href="/">home</a></li>
                        <li><a href="/organisations">certificates</a></li>
                        <li><a href="/wall">wall</a></li>
                        <li><a href="/auth/signin">login</a></li>
                        <li><a href="/schedule"><button className="clr">Schedule a meeting</button></a></li>
                    </ul>
                    {/* <ul className="links">
                        <li><a href="/">Home</a></li>
                        <li><a href="https://business.tokenlist.club/login">Business Account</a></li>
                        <li>
                            <a href="/auth/home">
                                <button>Wallet Login</button>
                            </a>
                        </li>
                    </ul> */}
                    <label htmlFor="nav-toggle" className="icon-burger">
                        <div className="line" />
                        <div className="line" />
                        <div className="line" />
                    </label>
                </div>
            </nav>
        </>
    );
}

export default NavBar;
